import {isFeatureEnabled} from '@github-ui/feature-flags'
import {isStaff} from '@github-ui/stats'
import {type MouseEvent, useRef} from 'react'
import {navigateToOverviewThankYou} from '../navigate-to-overview-thank-you'

function hasModifierKey(event: MouseEvent<HTMLElement>) {
  return (
    event.getModifierState('Alt') ||
    event.getModifierState('Control') ||
    event.getModifierState('Meta') ||
    event.getModifierState('Shift')
  )
}

export function OverviewThankYouTrigger() {
  const qualifyingClicksRef = useRef(0)

  return (
    <strong
      className="color-fg-default"
      onClickCapture={event => {
        if (
          event.button !== 0 ||
          hasModifierKey(event) ||
          !isFeatureEnabled('staff_pr_overview_delight') ||
          !isStaff()
        ) {
          qualifyingClicksRef.current = 0
          return
        }

        qualifyingClicksRef.current =
          event.detail === 1 || event.detail === qualifyingClicksRef.current + 1 ? event.detail : 0

        if (qualifyingClicksRef.current === 3) {
          qualifyingClicksRef.current = 0
          navigateToOverviewThankYou()
        }
      }}
      onAuxClickCapture={() => {
        qualifyingClicksRef.current = 0
      }}
    >
      Looking for an old friend?
    </strong>
  )
}
